import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
// UI
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/antd.less'
import 'swiper/css/bundle'

import 'lib-flexible'
import moment from 'moment'

Vue.prototype.$moment = moment;

Vue.config.errorHandler = error => {
    console.log('error', error);
};

Vue.config.productionTip = false;

// API
Vue.prototype.push = (url) => {
    router.push(url).then(success => {
    }).catch(error => {
        // ...
    })
};

import Utils from './utils'

Vue.prototype.$utils = Utils;

Vue.use(Antd);

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app');
